const state = {
  customers: [],
  pickerOptions: {},
  orgTypes: [],
  orgClasses: [],
  modeList: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js